import React from 'react';
import { inject, observer } from 'mobx-react';
import { Table, Row, Col, Input } from 'antd';
import { toJS } from 'mobx';
import AppDatasBody from '../util/AppDatasBody';
const store = ['appInfoStore'];

@inject(...store)
@observer
class AppInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
    }
  }

  componentDidMount() {
    const { appInfoStore: { getList, getColumns } } = this.props;
    getList();
    getColumns();
  }
  componentWillUnmount() {
    const { appInfoStore: { init } } = this.props;
    init();
  }

  render() {
    const { location, appInfoStore: {
      columns, list, loading, count, current, pageSize, setMobxState,
    } } = this.props;
    const valueName = this.state.name.trim();
    return (
      <div className='price'>
        <AppDatasBody location={location}>
          <Row className="cs-search-mylist">
            <Col span={8}>
              <Row className='cs-search-mylist-single'>
                <Col span={8} className='price-label'> <label>应用名称：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入应用名称'
                    onChange={e => {
                      this.setState({ name: e.target.value });
                      setMobxState({ current: 1 });
                    }}/>
                </Col>
              </Row>
            </Col>
          </Row>
          <Table columns={toJS(columns)}
            dataSource={toJS(list).filter(v => !valueName || (v && v.s_name && v.s_name.indexOf(valueName) >= 0))}
            loading={loading}
            rowKey="s_id"
            // scroll={{ y: 700 }}
            className='list-table'
            pagination={{
              current,
              pageSize,
              total: count,
              showTotal: (total) => `共${total}条`,
              showSizeChanger: true,
              showQuickJumper: true,
              onChange: (current, pageSize) => {
                setMobxState({ current, pageSize });
              },
              onShowSizeChange: (current, pageSize) => {
                setMobxState({ current: 1, pageSize });
              }
            }}
          />
        </AppDatasBody>
      </div>
    );
  }
}
export default AppInfo;


// WEBPACK FOOTER //
// ./src/components/price/AppInfo.js